import { FLAVOR_BY_ID, FLAVOR_GROUPS } from '../../../vibe/definitions';

export default function FlavorChips({ flavorIds = [], onToggle, disabled }) {
  return (
    <section aria-labelledby="vibe-flavor-heading">
      <h3 id="vibe-flavor-heading" className="text-sm font-semibold text-white">Flavor</h3>
      <p className="mb-3 text-xs text-white/70">Optional. Choose any that fit.</p>
      <div className="space-y-3">
        {FLAVOR_GROUPS.map((group) => (
          <div key={group.id}>
            <h4 className="mb-1.5 text-[11px] font-medium uppercase tracking-wide text-white/50">
              {group.label}
            </h4>
            <div className="flex flex-wrap gap-2" role="group" aria-label={group.label}>
              {group.flavorIds.map((flavorId) => {
                const flavor = FLAVOR_BY_ID[flavorId];
                if (!flavor) return null;
                const selected = flavorIds.includes(flavor.id);
                return (
                  <button
                    key={flavor.id}
                    type="button"
                    aria-pressed={selected}
                    disabled={disabled}
                    onClick={() => onToggle?.(flavor.id)}
                    className={`rounded-full border px-3 py-1.5 text-sm font-medium leading-snug focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-white ${
                      selected
                        ? 'border-white bg-white text-gray-950'
                        : 'border-white/20 bg-white/5 text-gray-100'
                    }`}
                  >
                    {selected ? `✓ ${flavor.label}` : flavor.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
